<template>
  <div style="margin-top: -20px">
    <el-input
      placeholder="搜索人员"
      v-model="word"
      size="mini"
      class="input-with-select"
    >
      <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
    </el-input>
    <div style="height: 50vh; overflow-y: auto; margin-bottom: 80px">
      <el-row
        type="flex"
        align="middle"
        justify="start"
        v-for="item in list"
        style="height: 45px; border-bottom: 1px solid #eee; padding-left: 15px"
      >
        <el-checkbox
          v-model="item.ischecked"
          @change="onChecked($event, item)"
          >{{ item.name }}</el-checkbox
        >
      </el-row>
    </div>
    <div
      style="
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        bottom: 10px; ;
      "
    >
      <el-button type="primary" @click="setUser">确定</el-button>
      <p>已选择：{{ checklist.length }}人</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "sel_staff",
  components: {},
  data() {
    return {
      selmode: 1, //1单选2多选
      usertype: "",
      subtaskid: "",
      word: "",
      list: [],
      checklist: [],
    };
  },
  methods: {
    async showInfo(type, mode, subtaskid) {
      this.selmode = mode;
      this.usertype = type;
      this.subtaskid = subtaskid;
      this.search();
    },
    async search() {
      this.list = await this.$api.request.get("/staff/get_userlist", {
        params: {
          type: this.usertype,
          subtaskid: this.subtaskid,
          word: this.word,
        },
      });
    },
    setUser() {
      if (this.checklist.length == 0) {
        return;
      }
      this.$emit("staffSelected", this.checklist);
    },
    onChecked(e, item) {
      if (this.selmode == 1 && e) {
        this.checklist = [];
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].id != item.id) this.list[i].ischecked = false;
        }

        this.checklist.push(item);
      } else {
        if (e) {
          this.checklist.push(item);
        } else {
          for (var i = 0; i < this.checklist.length; i++) {
            if (this.checklist[i].id == item.id) {
              this.checklist.splice(i, 1);
              break;
            }
          }
        }
      }
    },
  },
};
</script>
